class Breadcrumb {

	constructor() {
		this.init();
	}

	init() {
    ( function( $ ) {
      var $window = $(window);

      function breadCrumbMobile(){
  			if($window.width() < 991){
  				$('.floating-breadcrumb span').css('display', 'none');
  				var designated_survivor = $('.floating-breadcrumb span.breadcrumb_last').parent().find('a');

  				if(!$('.floating-breadcrumb .container > a').length){
  					$('.floating-breadcrumb .container').append(designated_survivor.clone());
  				}
  			}else{
  				$('.floating-breadcrumb span').css('display', '');
  				$('.floating-breadcrumb .container > a').remove();
  			}
  		}

  		breadCrumbMobile();

  		$(window).on('resize', function(){
  			breadCrumbMobile();
  		});
    }( jQuery ) );
	}
}

export default Breadcrumb;
